// Q&A / Community is fully built but not yet ready to show to users.
// Opt-in via REACT_APP_SHOW_QA=true so it stays hidden by default.
export const SHOW_QA = process.env.REACT_APP_SHOW_QA === 'true';
